import React from 'react'
import PropTypes from 'prop-types'
import Fade from 'react-reveal/Fade'

import VideoPlayer from 'agency/digital_renderer/components/VideoPlayer'
import DarkStudyImage from '../../assets/dark_study.jpg'

import ContentHolder from '../../ui/ContentHolder'
import styles from './styles.scss'

const Welcome = (props) => {
  const {
    campaignProposal,
    campaignProposal: { cover_letter, options },
  } = props

  const hasVideo = options && options.video_provider && options.video_id

  return (
    <div className={styles.root} style={{ backgroundImage: `url(${DarkStudyImage})` }}>
      <ContentHolder>
        <div className={styles.content}>
          <Fade>
            <div className={styles.column}>
              <h2 className={styles.title}>Welcome</h2>
              <p className={styles.bodyText}>{cover_letter}</p>
            </div>
          </Fade>

          {hasVideo && (
            <div className={styles.column}>
              <div className={styles.video}>
                <VideoPlayer dataSource={campaignProposal} />
              </div>
            </div>
          )}
        </div>
      </ContentHolder>
    </div>
  )
}

Welcome.propTypes = {
  campaignProposal: PropTypes.object.isRequired,
  vendorName: PropTypes.string,
}

export default Welcome
